import { useTranslation } from 'react-i18next';
import { changeLanguage } from '@/i18n';
import { LanguageIcon } from '@heroicons/react/24/outline';

interface LanguageSwitcherProps {
  className?: string;
  showIcon?: boolean;
}

export const LanguageSwitcher = ({ className = '', showIcon = false }: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation();
  const activeLang = i18n.language.startsWith('en') ? 'en' : 'fr';

  return (
    <div
      className={className}
      role="group"
      aria-label={t('app.language')}
      style={{
        display: 'inline-flex',
        border: '1px solid #d1d5db',
        borderRadius: '999px',
        overflow: 'hidden',
        backgroundColor: '#ffffff'
      }}
    >
      {showIcon && (
        <span
          aria-hidden="true"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingLeft: '8px',
            color: '#6b7280'
          }}
        >
          <LanguageIcon style={{ width: '14px', height: '14px' }} />
        </span>
      )}
      <button
        type="button"
        onClick={() => changeLanguage('fr')}
        aria-pressed={activeLang === 'fr'}
        title={t('app.french')}
        style={{
          padding: '4px 10px',
          border: 'none',
          background: activeLang === 'fr' ? '#8C1843' : 'transparent',
          color: activeLang === 'fr' ? '#ffffff' : '#374151',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
      >
        FR
      </button>
      <button
        type="button"
        onClick={() => changeLanguage('en')}
        aria-pressed={activeLang === 'en'}
        title={t('app.english')}
        style={{
          padding: '4px 10px',
          border: 'none',
          background: activeLang === 'en' ? '#8C1843' : 'transparent',
          color: activeLang === 'en' ? '#ffffff' : '#374151',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
      >
        EN
      </button>
    </div>
  );
};
